import styled from 'styled-components';

import { fontWeightMedium } from 'approot/shared/styles/typography.style';
import { grey10 } from 'approot/shared/styles/colours.style';

export const ActivitySettingsLabel = styled.div`
  color: ${grey10};
  text-overflow: ellipsis;
  overflow: hidden;
  strong {
    font-weight: ${fontWeightMedium};
  }
`;
